// Mock data with updated unique images for each service

export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    description: "Protect your brand identity with comprehensive trademark registration services.",
    icon: "Shield",
    backgroundImage: "https://images.pexels.com/photos/8731031/pexels-photo-8731031.jpeg"
  },
  {
    id: 2,
    title: "Copyright Registration",
    description: "Secure your original creative works with official copyright registration.",
    icon: "FileText",
    backgroundImage: "https://images.unsplash.com/photo-1628665843485-547b1449ac8c"
  },
  {
    id: 3,
    title: "Company Formation",
    description: "Establish your business entity with professional LLC or Corporation formation.",
    icon: "Building",
    backgroundImage: "https://images.pexels.com/photos/8373815/pexels-photo-8373815.jpeg"
  },
  {
    id: 4,
    title: "Comprehensive Trademark Search",
    description: "Avoid costly conflicts with thorough trademark searches across all databases.",
    icon: "Search",
    backgroundImage: "https://images.unsplash.com/photo-1769794370961-3cff43b1034e"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    description: "Unlock powerful Amazon seller tools with Brand Registry enrollment assistance.",
    icon: "Package",
    backgroundImage: "https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "$45",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Get Started Now"
  },
  {
    id: 2,
    name: "Enhanced",
    price: "$149",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Choose Enhanced"
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$299",
    federal: "+ Federal Filing Fee",
    recommended: true,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Choose Deluxe"
  },
  {
    id: 4,
    name: "Platinum",
    price: "$349",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Choose Platinum"
  }
];

export const uspsSupport = [
  {
    id: 1,
    icon: "Shield",
    title: "100% Secure Process",
    description: "Your trademark application is handled with complete confidentiality and security."
  },
  {
    id: 2,
    icon: "Clock",
    title: "Fast Turnaround",
    description: "Quick processing with expedited options available for urgent trademark needs."
  },
  {
    id: 3,
    icon: "Award",
    title: "Expert Legal Team",
    description: "15+ years of experience in trademark law and brand protection strategies."
  },
  {
    id: 4,
    icon: "DollarSign",
    title: "Affordable Pricing",
    description: "Transparent rates starting at just $45 with no hidden fees or surprises."
  },
  {
    id: 5,
    icon: "CheckCircle",
    title: "98% Success Rate",
    description: "Proven track record of successful trademark registrations across all industries."
  },
  {
    id: 6,
    icon: "Headphones",
    title: "24/7 Support",
    description: "Round-the-clock customer service to answer questions and provide guidance."
  },
  {
    id: 7,
    icon: "FileText",
    title: "Complete Documentation",
    description: "All paperwork handled professionally with detailed tracking and updates."
  },
  {
    id: 8,
    icon: "Users",
    title: "5,000+ Clients Served",
    description: "Trusted by thousands of businesses and individuals across the United States."
  }
];

export const uspsProfessional = [
  {
    id: 1,
    icon: "Target",
    title: "Precise Application Filing",
    description: "Accurate trademark applications filed with USPTO to avoid delays and rejections."
  },
  {
    id: 2,
    icon: "Search",
    title: "Comprehensive Search",
    description: "Thorough trademark searches to identify potential conflicts before filing."
  },
  {
    id: 3,
    icon: "Bell",
    title: "Trademark Monitoring",
    description: "Continuous monitoring of your trademark to protect against infringement."
  },
  {
    id: 4,
    icon: "FileCheck",
    title: "Office Action Response",
    description: "Expert handling of USPTO office actions to ensure successful registration."
  },
  {
    id: 5,
    icon: "Globe",
    title: "Nationwide Coverage",
    description: "Federal trademark protection across all 50 states and US territories."
  },
  {
    id: 6,
    icon: "Zap",
    title: "Amazon Brand Registry",
    description: "Seamless enrollment assistance for Amazon Brand Registry program."
  },
  {
    id: 7,
    icon: "Lock",
    title: "Legal Compliance",
    description: "Full compliance with USPTO regulations and trademark laws."
  },
  {
    id: 8,
    icon: "TrendingUp",
    title: "Brand Growth Strategy",
    description: "Strategic guidance to maximize your trademark portfolio value."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Award",
    title: "Industry-Leading Expertise",
    description: "Our team of trademark attorneys and specialists bring over 15 years of combined experience in intellectual property law. We've successfully registered over 5,000 trademarks across diverse industries, giving us unmatched insights into what works."
  },
  {
    id: 2,
    icon: "DollarSign",
    title: "Transparent & Affordable Pricing",
    description: "No hidden fees, no surprises. Our pricing is straightforward with packages starting at just $45. We believe brand protection should be accessible to businesses of all sizes, from startups to established enterprises."
  },
  {
    id: 3,
    icon: "Headphones",
    title: "Dedicated Support Throughout",
    description: "You're never alone in the process. From initial consultation to final registration, our dedicated case managers provide personalized support 24/7. We keep you informed at every step with real-time updates and clear communication."
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Information Collection",
    description: "We begin by gathering comprehensive details about your brand, business, and trademark needs. Our team conducts an initial consultation to understand your goals, target market, and brand identity. This foundational step ensures we file the most accurate and complete application."
  },
  {
    id: 2,
    step: "02",
    title: "Research and Search Report",
    description: "Our experts perform an extensive trademark search across USPTO databases, state registrations, and common law usage. We analyze potential conflicts, assess registration likelihood, and provide a detailed search report with recommendations to strengthen your application."
  },
  {
    id: 3,
    step: "03",
    title: "Application and Submission",
    description: "We prepare and file your trademark application with the USPTO, ensuring all documentation meets federal requirements. Our team monitors your application status, handles office actions, and guides you through the entire registration process until your trademark is secured."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "E-commerce Entrepreneur",
    service: "Trademark Registration",
    content: "Amazon Trademark Registration made the entire process seamless. Their expertise saved me months of confusion and got my trademark approved without any issues. The $299 Deluxe package was worth every penny!",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Startup Founder",
    service: "Comprehensive Trademark Search",
    content: "The comprehensive trademark search they provided was invaluable. They found potential conflicts I never would have discovered on my own, saving my business from costly rebranding. Highly professional service!",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    role: "Amazon Seller",
    service: "Amazon Brand Registry",
    content: "Their Amazon Brand Registry service was exceptional. Within weeks, I had full access to A+ Content and brand protection tools. My sales increased by 40% after enrollment. Best investment I've made!",
    rating: 5
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Product Designer",
    service: "Copyright Registration",
    content: "Copyright registration was quick and professional. They handled all the paperwork and kept me updated throughout. Protected my creative designs efficiently. Couldn't ask for better service!",
    rating: 5
  },
  {
    id: 5,
    name: "Amanda Stevens",
    role: "Small Business Owner",
    service: "Company Formation",
    content: "Company formation and trademark registration in one package was perfect for my new venture. The team was knowledgeable, responsive, and made everything stress-free. Started my business the right way!",
    rating: 5
  },
  {
    id: 6,
    name: "Robert Wilson",
    role: "Online Retailer",
    service: "Trademark Registration",
    content: "Best investment for my business. The trademark protection gave me complete control over my brand identity. The Essentials package at $45 was perfect for my budget. Great value and excellent results!",
    rating: 5
  },
  {
    id: 7,
    name: "Emily Parker",
    role: "Fashion Brand Owner",
    service: "Trademark Registration",
    content: "The Platinum package provided comprehensive protection for my fashion brand. The cease and desist letter service already proved valuable when dealing with copycats. Worth every dollar!",
    rating: 5
  },
  {
    id: 8,
    name: "James Anderson",
    role: "Tech Startup CEO",
    service: "Company Formation",
    content: "They handled my LLC formation and trademark registration simultaneously. The coordination was perfect, and everything was completed faster than expected. Professional service from start to finish!",
    rating: 5
  },
  {
    id: 9,
    name: "Lisa Martinez",
    role: "Content Creator",
    service: "Copyright Registration",
    content: "Protecting my content was crucial, and they made copyright registration simple. The team explained everything clearly and processed my application quickly. Now my work is legally protected!",
    rating: 5
  },
  {
    id: 10,
    name: "Kevin Brown",
    role: "Manufacturing Business Owner",
    service: "Comprehensive Trademark Search",
    content: "The trademark search report was incredibly detailed. They identified issues I hadn't considered and recommended strategic adjustments. This thorough research saved me from potential legal problems down the road!",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is trademark registration and why do I need it?",
    answer: "Trademark registration is the legal process of securing exclusive rights to your brand name, logo, or slogan with the USPTO. It provides federal protection across all 50 states, prevents others from using similar marks, enables you to use the ® symbol, and is required for Amazon Brand Registry. Registration protects your brand identity and gives you legal grounds to stop infringement."
  },
  {
    id: 2,
    question: "How long does the trademark registration process take?",
    answer: "The complete trademark registration process typically takes 6-12 months from filing to approval. Initial USPTO examination begins within 3-4 months. If approved, your mark is published for opposition (30 days), then registered. Our expedited services can help speed up certain steps, and we handle all office actions promptly to avoid delays."
  },
  {
    id: 3,
    question: "What's included in the $45 Essentials package?",
    answer: "The Essentials package includes case review, case filing with USPTO, basic trademark search, state e-filing assistance, and trademark securing. This package is perfect for straightforward trademarks with minimal conflict risk. Note that federal filing fees ($250-$350 per class) are separate and paid directly to the USPTO."
  },
  {
    id: 4,
    question: "What's the difference between your pricing packages?",
    answer: "Essentials ($45) covers basic filing. Enhanced ($149) adds direct hit search, trademark alerts, and risk assessment. Deluxe ($299) - our most popular - includes monitoring, complete documentation, and a dedicated case manager. Platinum ($349) provides comprehensive search reports, priority service, and cease & desist letter assistance. All packages exclude USPTO filing fees."
  },
  {
    id: 5,
    question: "Do I need a trademark search before filing?",
    answer: "Yes, a comprehensive trademark search is crucial to avoid conflicts and rejection. Our search examines USPTO databases, state registrations, common law usage, and domain names. This identifies potential conflicts before filing, saving time and money. Enhanced, Deluxe, and Platinum packages include thorough searches, while Essentials includes basic search only."
  },
  {
    id: 6,
    question: "Can you help me with Amazon Brand Registry enrollment?",
    answer: "Absolutely! Our Amazon Brand Registry service guides you through the entire enrollment process. We ensure your trademark meets Amazon's requirements, assist with application submission, and help you access powerful seller tools like A+ Content, Sponsored Brands, and brand protection features. This service can be added to any trademark registration package."
  },
  {
    id: 7,
    question: "What happens if my trademark application is rejected?",
    answer: "If the USPTO issues an office action (objection), our team provides expert response services. We analyze the objection, develop legal arguments, and submit a comprehensive response within the required timeframe. Our 98% success rate comes from our expertise in handling office actions. Enhanced and higher packages include office action response support."
  },
  {
    id: 8,
    question: "How is copyright registration different from trademark registration?",
    answer: "Trademarks protect brand identifiers (names, logos, slogans) that distinguish your products or services. Copyrights protect original creative works like product descriptions, images, videos, and written content. For Amazon sellers, trademarks are required for Brand Registry, while copyrights protect your product listings and marketing materials. We offer both services."
  },
  {
    id: 9,
    question: "Do I need to form a company before registering a trademark?",
    answer: "No, you can file as an individual. However, forming an LLC or Corporation offers liability protection and professional credibility. For Amazon sellers planning to scale, we recommend company formation before trademark filing to ensure ownership alignment with your Seller Central account. We offer combined packages for convenience."
  },
  {
    id: 10,
    question: "What are the USPTO filing fees and when do I pay them?",
    answer: "USPTO filing fees are $250-$350 per trademark class and are paid directly to the government, separate from our service fees. These are required for all applications and are non-refundable. We'll identify the appropriate trademark classes during your consultation and guide you through the payment process when filing your application."
  }
];
